import { observer, use$ } from '@legendapp/state/react';
import { Button, type ButtonProps, Group, Text, Tooltip } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useAutoBet } from '../../../hooks';
import { autoBetState$ } from '../../../state';
import { Spinner } from '../../Spinner';

export type AutoBetStartButtonProps = ButtonProps;

export const AutoBetStartButton = observer((props: AutoBetStartButtonProps) => {
  const { startAutoBetting, stopAutoBetting, isAutoBetting } = useAutoBet();
  const pickedBricks = use$(autoBetState$.pickedBricks);
  const { t } = useTranslation();

  return (
    <Tooltip
      hidden={pickedBricks.length > 0}
      label={t('autobet.autoBetStartButton.tooltip')}
    >
      <Button
        fullWidth
        onClick={() => {
          if (isAutoBetting) {
            stopAutoBetting();
          } else {
            startAutoBetting();
          }
        }}
        size="lg"
        {...props}
      >
        <Group>
          {isAutoBetting ? <Spinner size={24} /> : null}
          <Text fw={600} size="sm">
            {isAutoBetting
              ? t('autobet.autoBetStartButton.stop')
              : t('autobet.autoBetStartButton.start')}
          </Text>
        </Group>
      </Button>
    </Tooltip>
  );
});
